<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">

      <h3>{{ pageTitle }}</h3>
      <hr>
      
      <AppForm
        v-show="pageShowData"
        ref="pageForm" 
        v-bind:formParameter="PARAM"
        v-bind:permission="permission"
        v-on:form-input="onFormInput" >

        <div
          slot="jt-form-slot-_terminationDate">
          <br>
          <TemplateFeedback ref="terminationDateFeedback" />
        </div>

        <div
          slot="jt-form-slot-sectionProductSubscriptionLease">
          <PagePLTerminationFormLease
            ref="pageTableLease" />
        </div>

        <div
          slot="jt-form-slot-applicationTnCtext" v-html="tnc">
        </div>
        
      </AppForm>

      <TemplateFeedback ref="pageFeedback" />

      <button v-show="pageShowData" v-on:click="onCancelButtonClick" type="button" class="btn btn-default">
        Cancel
      </button>

      <TemplateButton v-show="hasAddOrEditPermission() && pageShowSumbit && pageCanSubmit && pageEnableSubmit" v-on:click="onSaveButtonClick" type="button" class="btn btn-success">
        Submit Application
      </TemplateButton>

      <TemplateButton v-show="approvalShowApprove" v-on:click="onApproveButtonClick" type="button" class="btn btn-danger">
        Approve
      </TemplateButton>

      <TemplateButton v-show="false && approvalShowReach" v-on:click="onReachTerminationButtonClick" type="button" class="btn btn-danger">
        Simulate Reach Termination Effective Date
      </TemplateButton>

      <TemplateButton v-show="false && approvalShowReach14" v-on:click="onReachTermination14ButtonClick" type="button" class="btn btn-danger">
        Simulate Reach 14 days after Termination Effective Date
      </TemplateButton>

      <TemplateButton v-show="false && approvalShowRefund" v-on:click="onCompleteButtonClick" type="button" class="btn btn-danger">
        Refund
      </TemplateButton>

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppForm from "@/components/App/AppForm";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"
import PagePLTerminationFormLease from "@/components/Page/ParkingLicense/PagePLTerminationFormLease";
import IBGBankConfig from "@/components/Param/IBG"

var querystring = require('querystring');
var moment = require('moment');

let commencementDateValidate = function(date) {
  return true;
}

let boostrapGridCol6 = {
  'class': 'col-lg-6',
};

const PARAM = [
  {
    key: 'carparkID',
    text: 'Car Park',
    form_select: {
      data: [],
      formatSelectOptionValue: (data) => data.id, 
      formatSelectOptionText: (data) => data.carparkCode ? `${data.carparkCode} - ${data.name}` : data.name,
    },
    form_chosen: true,
    form_edit_input_attr: {
      disabled: true,
    },
  },
  {
    key: 'licenseID',
    text: 'Parking License',
    form_select: {
      data: [],
      formatSelectOptionText: option => {
        let text = helper.plFormPLNum(option.licenseOperatorNum, option.carparkID);
        let customer = option['_customer'];
        text += customer ? ` - ${customer.name} (${customer.nationalID})` : '';
        return text;
      },
    },
    form_chosen: true,
    form_edit_input_attr: {
      disabled: true,
    },
  },
  {
    key: 'sectionProductSubscription',
    form_section: 'Product Subscription *',
  },
  {
    key: '_lease',
    form_label_attr: { style: 'display:none'},
    form_select: {
      data: [],
      formatSelectOptionText: option => {
        if(typeof option === 'string') {
          return option;
        }
        let text = `${option['leaseZone']} - ${option['leaseProductName']} - ${option['parkerName']} `;
        if(option['isParkAide']) {
          let parkaideStatus = '(Passcard: ParkAide Blocked)'
          // if(option['status'] === 'Active' || option['status'] === 'Pending Termination') {
          if(new moment() > helper.parseDateTime(option['commencementDate'])) {
            if(!option['isBlock']) {
              parkaideStatus = '(Passcard: ParkAide Active)';
            }
          }
          // }
          text += parkaideStatus;
        } else {
          text += option['leasePasscard'] ? '(Passcard: ' + option['leasePasscard'] + ')' : '';
        }
        return text;
      },
    },
    form_edit_hide: true,
    form_input_attr: {
      'multiple' : true,
      'data-placeholder': 'Select product subscription',
    },
    form_chosen_multiple: true,
  },
  {
    key: 'sectionProductSubscriptionLease',
    form_html: () => '',
  },
  {
    key: '_terminationDate',
    text: 'Termination Effective Date (Last Day of Parking) *',
    form_datepicker: {
      beforeShowDay: function(date) {
        return commencementDateValidate(date);
      },
    },
    form_edit_input_attr: {
      disabled: true,
    },
  },
  {
    key: '_terminationReason',
    text: 'Reason for the Termination *',
    form_textarea: true,
    form_input_attr: {
      'maxlength': '128',
    },
    // form_edit_input_attr: {
    //   disabled: true,
    // },
  },
  {
    key: '_applyDate',
    text: 'Termination Application Date',
    form_datepicker: true,
    form_edit_input_attr: {
      disabled: true,
    },
  },
  {
    key: 'contactNo',
    text: 'Contact No. *',
    form_phone: true,
    form_edit_input_attr: {
      disabled: true,
    },
  },
  {
    key: 'createDate',
    text: 'Submission Date',
    form_add_hide: true,
    form_input_validation: [],
    form_edit_input_attr: {
      disabled: true,
    },
  },
  {
    key: 'terminationStatus',
    text: 'Termination Status',
    form_add_hide: true,
    form_input_validation: [],
    form_edit_input_attr: {
      disabled: true,
    },
  },
  {
    key: 'refundMethod',
    text: 'Refund Method',
    form_default: 0,
    // form_input_attr: {
    //   disabled: true,
    // },
    form_select: [
      {0:'GIRO'}, 
      {1:'Cheque'},
    ]
  },
  {
    key: 'terminationGiroSection',
    form_section: 'GIRO Information',
  },
  {
    key: 'terminationGiroAccountHolder',
    text: 'Bank Account Holder Name *',
    form_input_validation: [],
  },
  {
    key: 'terminationGiroEmail',
    text: 'Email *',
    form_input_validation: [],
  },
  {
    key: 'terminationGiroBank',
    text: 'Bank Name *',
    form_input_validation: [],
    form_chosen: true,
    form_select: {
      data: IBGBankConfig,
      formatSelectOptionText: (dataItem) => dataItem.name,
    }
  },
  {
    key: 'terminationGiroBankAccountType',
    text: 'Bank Account Type *',
    form_input_validation: [],
    form_default: 0,
    form_select: [
      {'current':'Current Account'}, 
      {'saving':'Saving Account'},
    ]
  },
  {
    key: 'terminationGiroBankAccountNo',
    text: 'Bank Account No. *',
    form_input_validation: [],
    form_muted: '',
  },
  {
    key: 'terminationGiroVerification',
    form_section: 'GIRO Verification Method',
  },
  {
    key: 'terminationGiroRemark',
    form_html: () => 'Please fill in at least one of the GIRO Verification Method at below.',
  },
  {
    key: 'terminationGiroNewIC',
    text: 'New I/C No.',
    form_input_validation: [],
    form_default: '',
  },
  {
    key: 'terminationGiroOldIC',
    text: 'Old I/C No.',
    form_input_validation: [],
    form_default: '',
  },
  {
    key: 'terminationGiroBusinessRegNo',
    text: 'Business Registration No.',
    form_input_validation: [],
    form_default: '',
  },
  {
    key: 'terminationChequeSection',
    form_section: 'Posting Address Information',
  },
  {
    key: 'terminationChequePayableTo',
    text: 'Cheque Payable To *',
    form_input_validation: [],
  },
  {
    key: 'terminationChequeAddress1',
    text: 'Address 1 *',
    form_container_attr: boostrapGridCol6,
    form_input_validation: [],
  },
  {
    key: 'terminationChequeAddress2',
    text: 'Address 2',
    form_container_attr: boostrapGridCol6,
    form_input_validation: [],
  },
  {
    key: 'terminationChequeAddress3',
    text: 'Address 3',
    form_container_attr: boostrapGridCol6,
    form_input_validation: [],
  },
  {
    key: 'terminationChequePostalCode',
    text: 'Postal Code *',
    form_container_attr: boostrapGridCol6,
    form_input_validation: [],
  },
  {
    key: 'terminationChequeCity',
    text: 'City *',
    form_container_attr: boostrapGridCol6,
    form_input_validation: [],
    form_select: [],
    form_chosen: true,
  },
  {
    key: 'terminationChequeState',
    text: 'State *',
    form_container_attr: boostrapGridCol6,
    form_input_validation: [],
    form_input_attr: {
      'disabled' : 1,
    },
    form_select: [],
  },
  {
    key: 'terminationChequeCountry',
    text: 'Country *',
    form_container_attr: boostrapGridCol6,
    form_input_validation: [],
    form_input_attr: {
      'disabled' : 1,
    },
    form_select: [],
  },
  {
    form_section: 'Termination Terms and Conditions',
  },
  {
    key: 'applicationTnCtext',
    form_html: () => '',
    // form_html: () => `NOTES: It is important to read all the Term and Conditions delivered with this form.<br>
    //   <br>
    //   1.0 Written or online termination notice of one (1) calendar month shall be given before the termination date.<br>
    //   2.0 Conditions precedent to the refund of deposit, failing which service provider shall entitle to retain the deposit: -<br>
    //   <ul>
    //   <li>(a) the access card/tag being returned to service provider in good working order and condition within 14 days from the termination date</li>
    //   <li>(b) all outstanding payment due to service provider having being fully paid up to the termination date</li>
    //   </ul>
    //   3.0 Parking License must be maintained for a minimum continuous period of ONE (1) calendar month prior to termination as stipulated in our Terms and Conditions of Parking License Agreement.<br>
    //   4.0 All terms and conditions as stated in Parking License Application Form shall apply and having being fully complied with.<br>
    //   5.0 Please proceed to the Car Park Site Office to fill up Lost/Faulty/Damage/Return Passcard Form and surrender the parking access card/tag within 14 days from the termination date (last day).<br>
    //   6.0 Any Refund, if applicable, shall be credited directly into the customer's bank account or at the customer's request where the refund is made via cheque.`,
  },
  {
    key: 'applicationTnC',
    text: 'I agree and accept the Termination Terms and Conditions *',
    form_checkbox: true,
    form_edit_input_attr: {
      disabled: true,
    },
  },
  {
    key: 'applicationStaff',
    text: 'Staff Name *',
    form_select: [],
    form_chosen: true,
    form_edit_input_attr: {
      disabled: true,
    },
  },
  {
    key: 'applicationStaffNo',
    text: 'Staff No *',
    form_input_attr: {
      disabled: true,
    },
  },
];

const PARAM_MAP = helper.transformParamToMap(PARAM);

export default {
  name: "PagePLTerminationForm",
  components: {
    TemplateBasic,
    TemplateButton,
    TemplateFeedback,
    AppForm,
    PagePLTerminationFormLease,
  },
  data () {
    return {
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Parking License', url: '/parkinglicense' },
        { name: 'Termination Application', url: '/plTermination' },
      ],

      API_PATH: "/api2/application/",
      PARAM,
      PARAM_MAP,
      IBGBankConfig,

      tnc: '',

      pageTitle: null,
      pageShowData: false,
      pageShowSumbit: false,
      pageCanSubmit: false,
      pageEnableSubmit: true,

      pageStaff: null,
      pageCarpark: null,
      pageZone: null,
      pageCustomer: null,
      pagePasscard: null,

      pageLicense: null,
      pageSeason: undefined,
      pageFees: {},
      pageTermination: {},
      pagePasscardReturn: {},
      pagePasscardLostDamagedFaulty: {},
      pageParker: undefined,

      approvalShowApprove: false,
      approvalShowReach: false,
      approvalShowReach14: false,
      approvalShowRefund: false,

      oldSelection: [],

      forceTerminationOnLastDayOfMonth: false,
    }
  },
  mounted() {
    this.permission = this.$route.path.includes('Force') ? 'secretadmin' : helper.getPermission(this)
    if(!helper.hasViewPermission(this.permission)) {
      return;
    }
    
    if(!this.$route.path.includes('Force')) {
      this.$nextTick(() => {
        helper.setSidebar('/plTermination');
      });

      this.PARAM_MAP['_applyDate'].form_add_hide = true;
      this.PARAM_MAP['_applyDate'].form_edit_hide = true;
    }

    if(window.location.href.includes('localhost')) {
      this.PARAM_MAP['_applyDate'].form_add_hide = false;
      this.PARAM_MAP['_applyDate'].form_edit_hide = false;
    }

    if(helper.checkRoleIsParker()) {
      this.PARAM_MAP['refundMethod'].form_input_attr = { disabled: true };
    }
    
    this.hideFormFromKey('licenseID');
    this.loadCountry();

    try {
      let self = this;
      commencementDateValidate = (date) => {
        if(window.location.href.includes('localhost')) {
          return true
        }
        
        if(!self.$route.path.includes('Force')) {
          if(date < moment().startOf('day').toDate()) {
            return false;
          }
        }

        if(this.forceTerminationOnLastDayOfMonth) {
          if(moment(date).endOf('day').unix() !== moment(date).endOf('month').unix()) {
            return false;
          }
        }
        
        return true;
      }
      $('#jt-form-input-_terminationDate').datepicker('update');
    } catch (e) {
    }

    if(helper.checkRoleIsParker()) {
      this.PARAM_MAP['applicationStaff'].form_add_hide = true;
      this.PARAM_MAP['applicationStaffNo'].form_add_hide = true;
      this.PARAM_MAP['applicationStaff'].form_edit_hide = true;
      this.PARAM_MAP['applicationStaffNo'].form_edit_hide = true;
      this.PARAM_MAP['applicationStaff'].form_input_validation = [];
      this.PARAM_MAP['applicationStaffNo'].form_input_validation = [];
    }

    // TODO kw1 termination date cannot be earlier than commencement date
  },
  methods: {
    hideFormFromKey(key) {
      if(key === null) {
        this.pageShowSumbit = true;
      }

      let hide = false;
      let refundMethod = this.$refs['pageForm'].formData['refundMethod'];
      this.PARAM.forEach(parameter => {
        if(parameter.key === key) {
          hide = true;
        }

        if(hide) {
          parameter.form_hide = hide;
          return;
        }

        if(parameter.key && parameter.key.startsWith('terminationGiro')) {
          parameter.form_hide = !helper.compareID(refundMethod, 0);
          return;
        }

        if(parameter.key && parameter.key.startsWith('terminationCheque')) {
          parameter.form_hide = !helper.compareID(refundMethod, 1);
          return;
        }

        parameter.form_hide = hide;
      });
    },

    loadCountry() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading country data...');

      this.$http
        .get(
          helper.SERVER_URL + '/api2/country',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          helper.inputSelectSetOption(this.PARAM_MAP['terminationChequeCountry'], response.data);
          this.loadState();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'country data'));
        });
    },
    loadState() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading state data...');

      this.$http
        .get(
          helper.SERVER_URL + '/api2/state',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          helper.inputSelectSetOption(this.PARAM_MAP['terminationChequeState'], response.data);
          this.loadCity();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'state data'));
        });
    },
    loadCity() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading city data...');

      this.$http
        .get(
          helper.SERVER_URL + '/api2/city',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          helper.inputSelectSetOption(this.PARAM_MAP['terminationChequeCity'], response.data);
          this.loadStaff();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'city data'));
        });
    },

    // 1. load staff, customer & carpark
    // 2a. if add - init application, load license, license lease
    // 2b. if edit - load application, license (specific, for customer + carpark), application data, application lease
    // 3. load leases related (parker, season, season fees)
    loadStaff() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading staff data...');
      this.$http
        .get(
          helper.SERVER_URL + '/api2/personnel/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          helper.inputSelectSetOption(this.PARAM_MAP['applicationStaff'], response.data);
          this.loadCustomer();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'staff data'));
        });
    },
    loadCustomer() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading profile data...');
      this.$http
        .get(
          helper.SERVER_URL + '/api2/customer',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageCustomer = response.data;
          this.loadCarpark();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'profile data'));
        });
    },
    loadCarpark() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading car park data...');
      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();

          // helper.inputSelectSetOption(this.PARAM_MAP['carparkID'], this.pageCarpark = response.data);
          // this.loadZone();

          this.pageCarpark = response.data
          this.setCarparInput();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'car park data'));
        });
    },
    setCarparInput() {
      let feedbackItem = 'car park license data'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/license',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();

          let allParkingLicense = response.data;
          this.pageCarpark = this.pageCarpark.filter(k => {
            return allParkingLicense.find(j => j.carparkID === k.id)
          });

          helper.inputSelectSetOption(this.PARAM_MAP['carparkID'], this.pageCarpark);
          this.loadZone();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadZone() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading car park zone data...');
      this.$http
        .get(
          helper.SERVER_URL + '/api2/zone',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageZone = response.data;
          this.loadProduct();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'car park zone data'));
        });
    },
    loadProduct() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading car park product data...');
      this.$http
        .get(
          helper.SERVER_URL + '/api2/season',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageProduct = response.data;
          this.loadApplication();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'car park product data'));
        });
    },


    loadApplication() {
      let applicationID = this.$route.query.applicationID;
      if(applicationID) {
        this.PARAM_MAP['applicationStaff'].form_input_validation = []
        this.PARAM_MAP['applicationStaffNo'].form_input_validation = []

        let feedbackItem = 'parking license termination application info';
        this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
        this.$http
          .get(
            helper.SERVER_URL + '/api2/request?carparkID=' + this.$route.query.carparkID + '&applicationID=' + applicationID + '&type1=termination',
            helper.createAxiosConfig()
          )
          .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
            response.data = response.data.filter(k => k.createDate > 1545955200);

            let temp = response.data[0];
            let application = {};
            application['applicationID'] = temp['applicationID'];
            application['licenseID'] = temp['licenseID'];
            application['carparkID'] = temp['carparkID'];
            application['customerID'] = temp['customerID'];
            application['_terminationDate'] = helper.formatDate(temp['date1']);
            application['_terminationReason'] = temp['data5'];
            application['_applyDate'] = temp['date3'] ? helper.formatDate(temp['date3']) : helper.formatDate(temp['createDate']);
            application['contactNo'] = temp['data1'];
            application['createDate'] = temp['date3'] ? helper.formatDate(temp['date3']) : helper.formatDate(temp['createDate']);
            application['terminationStatus'] = temp['status2'];
            application['refundMethod'] = temp['data2'];
            application['applicationStaff'] = temp['data3'];
            application['applicationTnC'] = 1;
            application['status'] = temp['status2'];
            application['lease'] = response.data;

            try {
              application['dataRef'] = JSON.parse(temp['dataRef']);
              for(let key in application['dataRef']) {
                application[key] = application['dataRef'][key];
              }
            } catch(e) {
            }

            this.$refs['pageForm'].setForm(false, application);
            this.$refs['pageTableLease'].setLeaseData(application['lease'] = response.data, false);
            this.$refs['pageTableLease'].setLeaseSubscriptionStatusVisible(true);
            
            if(application['status'] === 'Pending Approval' || application['status'] === 'Pending') {
              this.approvalShowApprove = true;
              this.pageCanSubmit = true;
            } else if(application['status'] === 'Awaiting Effective Date') {
              this.approvalShowReach = true;
              this.pageCanSubmit = true;
              // this.PARAM.forEach(k => k['form_input_attr'] = {disabled : true});
            } else if(application['status'] === 'Pending Passcard Return') {
              this.approvalShowReach14 = true;
            } else if(application['status'] === 'Pending System Refund') {
              this.approvalShowRefund = true;
              this.PARAM.forEach(k => k['form_input_attr'] = {disabled : true});
            } else {
              this.PARAM.forEach(k => k['form_input_attr'] = {disabled : true});
            }

            if(!this.$route.query.pending) {
              this.PARAM.forEach(k => k['form_input_attr'] = {disabled : true});
              this.pageCanSubmit = false;
            }

            this.onTerminationDateChange();
            this.onApplicationStaffChange();
            this.onBankChange();

            this.pageTitle = 'Termination Application ' + helper.plFormPLTNum(application['applicationID'], application['carparkID']);
            this.pageShowData = true;

            this.loadLicense();
          })
          .catch(error => {
            this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
          })
      } else {
        this.pageIsAdd = true;
        this.pageCanSubmit = true;
        let tempData = this.$refs['pageForm'].getFormDefaultData();
        tempData.lease = [{}];
        tempData['carparkID'] = this.$route.query.carparkID || tempData['carparkID'];
        tempData['licenseID'] = this.$route.query.licenseID || tempData['licenseID'];

        let oneCalendarMonth = helper.getOneCalendarMonthLater(moment())
        tempData['_terminationDate'] = helper.formatDate(oneCalendarMonth);
        tempData['_applyDate'] = helper.formatDate(new moment());

        this.pageTitle = 'Termination Application';
        this.pageShowData = true;
        this.$refs['pageForm'].setForm(true, tempData);

        if(this.$refs['pageForm'].formData['carparkID']) {
          this.loadLicense();
        }
      }
    },

    loadLicense() {
      this.hideFormFromKey('licenseID');
      let formData = this.$refs['pageForm'].formData;

      let url = helper.SERVER_URL;
      if(!this.$refs['pageForm'].formIsAdd) {
        url += '/api2/license/' + formData['licenseID'];
      } else {
        url += '/api2/carpark/' + formData['carparkID'] + '/license/';
      }
      
      let feedbackItem = 'parking license data'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();

          // TODO kw1 only show active license & lease
          if(this.$refs['pageForm'].formIsAdd) {
            response.data = response.data.filter(k => k.status === 'Active');
          }
          this.pageLicense = response.data;

          response.data.forEach(k => {
            k['_carpark'] = this.pageCarpark.find(j => j.id === k.carparkID);
            k['_customer'] = this.pageCustomer.find(j => j.id === k.customerID);
          });

          helper.inputSelectSetOption(this.PARAM_MAP['licenseID'], response.data);
          this.hideFormFromKey('sectionProductSubscription');

          if(!this.$refs['pageForm'].formIsAdd) {
            formData['carparkID'] = response.data.find(k => helper.compareID(k.id, formData['licenseID']))['carparkID'];
            this.$refs['pageForm'].$forceUpdate();
            // this.loadApplicationData(formData['applicationData']);

            this.$refs['pageForm'].formData['lease'].forEach(k => k['leaseSelected'] = true);
            this.$refs['pageTableLease'].setLeaseData(this.$refs['pageForm'].formData['lease'], false);
            this.loadCustomerAddress();
            return;
          }

          try {
            if(JSON.parse(localStorage.getItem('user')).username === 'kahwei.chuah@july.technology') {
              formData['licenseID'] = response.data[0].id
              formData['terminationGiroBank'] = this.PARAM_MAP['terminationGiroBank'].form_select.data[0].id
              formData['terminationGiroBankAccountType'] = 'current'
              formData['terminationGiroBankAccountNo'] = '123456789012'
              formData['applicationTnC'] = 1
              formData['applicationStaff'] = this.PARAM_MAP['applicationStaff'].form_select[0].id
            }
          } catch(e) {
          }

          if(formData['licenseID'] && response.data.find(k => helper.compareID(k.id, formData['licenseID']))) {
            this.onLicenseChange();
          } else {
            this.$refs['pageFeedback'].setFeedbackMessage();
            formData['licenseID'] = null;
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadLicenseLease() {
      this.hideFormFromKey('sectionProductSubscription');

      this.tnc = null;
      this.pageSeason = null;
      this.pageParker = null;

      let feedbackItem = 'parking license lease data'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/license/' + this.$refs['pageForm'].formData['licenseID'] + '/lease/?current=1',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.latestLease = response.data;

          if(!this.$refs['pageForm'].formIsAdd) {
            this.pageLicenseLease = response.data;
            this.loadLicenseInvoiceLease();
            return;
          }
          
          if(this.$refs['pageForm'].formIsAdd) {
            response.data = response.data.filter(k => k.status === 'Active' && !k['stopBillDate']);
          }

          if(response.data.length === 0) {
            this.$refs['pageFeedback'].setFeedbackError('No active subscription available');
            return;
          }

          this.$refs['pageTableLease'].setLeaseData(this.$refs['pageForm'].formData['lease'] = response.data, true);
          this.loadLicenseInvoiceLease();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadLicenseInvoiceLease() {
      this.hideFormFromKey('sectionProductSubscription');

      let feedbackItem = 'parking license invoice bill data'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + `/api2/invoiceLease?billType=INV&licenseID=${this.$refs['pageForm'].formData['licenseID']}`,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          
          this.billINVLease = response.data.filter(k => k.type.endsWith(' INV'))
          this.loadLicenseInvoice();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadLicenseInvoice() {
      this.hideFormFromKey('sectionProductSubscription');

      let selectedLicense = helper.inputSelectFindOption(this.PARAM_MAP['licenseID'], this.$refs['pageForm'].formData['licenseID']);
      let customerID = selectedLicense.customerID
      let carparkID = selectedLicense.carparkID

      let feedbackItem = 'parking license invoice data'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + `/api2/invoice?billType=INV&customerID=${customerID}&carparkID=${carparkID}`,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          
          this.billINV = response.data.map(invoice => {
            invoice.leases = this.billINVLease.filter(k => k.invoiceID === invoice.id);
            invoice.leases.forEach(k => k.bill = invoice);
          })
          this.loadLicenseDNLease();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadLicenseDNLease() {
      this.hideFormFromKey('sectionProductSubscription');

      let feedbackItem = 'parking license debit note bill data'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + `/api2/dnLease?licenseID=${this.$refs['pageForm'].formData['licenseID']}`,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          
          this.billDNLease = response.data.filter(k => k.type.endsWith(' DN'))
          this.loadLicenseDN();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadLicenseDN() {
      this.hideFormFromKey('sectionProductSubscription');

      let selectedLicense = helper.inputSelectFindOption(this.PARAM_MAP['licenseID'], this.$refs['pageForm'].formData['licenseID']);
      let customerID = selectedLicense.customerID
      let carparkID = selectedLicense.carparkID

      let feedbackItem = 'parking license debit note data'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + `/api2/invoice?billType=DN&customerID=${customerID}&carparkID=${carparkID}`,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          
          this.billDN = response.data.map(invoice => {
            invoice.leases = this.billDNLease.filter(k => k.invoiceID === invoice.id);
            invoice.leases.forEach(k => k.bill = invoice);
          })
          this.loadLicenseCNLease();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadLicenseCNLease() {
      this.hideFormFromKey('sectionProductSubscription');

      let feedbackItem = 'parking license credit note bill data'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + `/api2/cnLease?licenseID=${this.$refs['pageForm'].formData['licenseID']}`,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          
          this.billCNLease = response.data.filter(k => k.type.endsWith(' CN'))
          this.loadLicenseCN();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadLicenseCN() {
      this.hideFormFromKey('sectionProductSubscription');

      let selectedLicense = helper.inputSelectFindOption(this.PARAM_MAP['licenseID'], this.$refs['pageForm'].formData['licenseID']);
      let customerID = selectedLicense.customerID
      let carparkID = selectedLicense.carparkID

      let feedbackItem = 'parking license credit note data'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + `/api2/invoice?billType=CN&customerID=${customerID}&carparkID=${carparkID}`,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          
          this.billCN = response.data.map(invoice => {
            invoice.leases = this.billCNLease.filter(k => k.invoiceID === invoice.id);
            invoice.leases.forEach(k => k.bill = invoice);
          })
          this.loadCustomerContact();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },

    loadCustomerContact() {
      let customerID = helper.inputSelectFindOption(this.PARAM_MAP['licenseID'], this.$refs['pageForm'].formData['licenseID']).customerID;
      let customer = this.pageCustomer.find(k => helper.compareID(k.id, customerID));

      let feedbackItem = 'customer contact data'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/contact/' + customer['contact1'],
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageCustomerContact = helper.parseContact(response);
          let formData = this.$refs['pageForm'].formData;
          if(customer.isCompany) {
            formData['contactNo'] = this.pageCustomerContact['companyPICphone'];
            formData['terminationGiroAccountHolder'] = customer['name'];
            formData['terminationGiroEmail'] = this.pageCustomerContact['companyPICemail'];
          } else {
            formData['contactNo'] = this.pageCustomerContact['personalPhoneMobile'];
            formData['terminationGiroAccountHolder'] = customer['name'];
            formData['terminationGiroEmail'] = this.pageCustomerContact['personalEmail'];
          }
          
          this.loadPasscard();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },

    loadPasscard() {
      this.hideFormFromKey('licenseID');
      let formData = this.$refs['pageForm'].formData;

      let url = helper.SERVER_URL + '/api2/carpark/' + formData['carparkID'] + '/passcard/';

      let feedbackItem = 'parking license passcard'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pagePasscard = response.data;
          this.loadLeaseData();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },

    loadPasscardReturnApplication(licenseID) {
      this.hideFormFromKey('sectionProductSubscription');

      this.pagePasscardReturn[licenseID] = null;

      let feedbackItem = 'passcard return application';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          // helper.SERVER_URL + '/api2/season/' + seasonID + '/currentSeasonFees/',
          // helper.SERVER_URL + '/api2/request?type1=passcardTerminationReturn',
          helper.SERVER_URL + '/api2/request?type1=passcardTerminationReturn&licenseID=' + licenseID,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pagePasscardReturn[licenseID] = response.data;
          this.loadLeaseData();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadPasscardLostDamageFaultyApplication(licenseID) {
      this.hideFormFromKey('sectionProductSubscription');

      this.pagePasscardLostDamagedFaulty[licenseID] = null;

      let feedbackItem = 'lost/damaged/faulty application';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          // helper.SERVER_URL + '/api2/season/' + seasonID + '/currentSeasonFees/',
          // helper.SERVER_URL + '/api2/request?type1=passcardTerminationReturn',
          helper.SERVER_URL + '/api2/request?type1=passcardLostDamageFaulty&licenseID=' + licenseID,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pagePasscardLostDamagedFaulty[licenseID] = response.data.sort((a, b) => b.createDate - a.createDate);
          this.loadLeaseData();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },

    loadLeaseData() {
      let formData = this.$refs['pageForm'].formData;

      if(!this.pagePasscardReturn[formData['licenseID']]) {
        this.loadPasscardReturnApplication(formData['licenseID']);
        return;
      }

      if(!this.pagePasscardLostDamagedFaulty[formData['licenseID']]) {
        this.loadPasscardLostDamageFaultyApplication(formData['licenseID']);
        return;
      }

      if(this.tnc === undefined || this.tnc === null) {
        this.loadTerminationTnC();
        return;
      }

      if(!this.pageSeason) {
        this.loadSeason();
        return;
      }

      if(!this.pageParker) {
        this.loadParker();
        return;
      }

      let leases = formData['lease'];
      helper.inputSelectSetOption(this.PARAM_MAP['_lease'], [].concat('All Subscription', leases));

      try {
        if(JSON.parse(localStorage.getItem('user')).username === 'kahwei.chuah@july.technology') {
          formData['_lease'] = ['All Subscription']
          this.onFormInput(formData, this.PARAM_MAP['_lease'])
          return;
        }
      } catch(e) {
      }

      this.calculateParkingFees();
    },
    loadTerminationTnC() {
      let selectedCarpark = this.pageCarpark.find(k => helper.compareID(k.id, this.$refs['pageForm'].formData['carparkID']))
      let feedbackItem = 'termination terms and conditions'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/policy/terminate?operatorID=' + selectedCarpark.operatorID,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.tnc = response.data[0].policy;
          this.loadLeaseData();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadSeason() {
      this.hideFormFromKey('sectionProductSubscription');

      let feedbackItem = 'product data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/' + this.$refs['pageForm'].formData['carparkID'] + '/season/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.pageSeason = response.data;
            this.loadLeaseData();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadSeasonFees(seasonID) {
      this.hideFormFromKey('sectionProductSubscription');

      this.pageFees[seasonID] = null;

      let feedbackItem = 'product fees data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          // helper.SERVER_URL + '/api2/season/' + seasonID + '/currentSeasonFees/',
          helper.SERVER_URL + '/api2/season/' + seasonID + '/seasonFees/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            // if(this.pageFees[seasonID] = response.data[0]) {
            // if(this.pageFees[seasonID] = response.data.find(k => k.isActive)) {
            if(this.pageFees[seasonID] = response.data) {
              this.$refs['pageFeedback'].setFeedbackMessage();
              this.calculateParkingFees();
            } else {
              this.$refs['pageFeedback'].setFeedbackError('No active ' + feedbackItem + ' available.');
            }
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadSeasonTermination(seasonID) {
      this.hideFormFromKey('sectionProductSubscription');

      this.pageTermination[seasonID] = null;

      let feedbackItem = 'product termination terms';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          // helper.SERVER_URL + '/api2/season/' + seasonID + '/currentSeasonFees/',
          helper.SERVER_URL + '/api2/season/' + seasonID + '/terms/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageTermination[seasonID] = response.data
          this.calculateParkingFees();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadParker() {
      this.hideFormFromKey('sectionProductSubscription');

      let customerID = helper.inputSelectFindOption(this.PARAM_MAP['licenseID'], this.$refs['pageForm'].formData['licenseID']).customerID;

      let feedbackItem = 'parker data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/customer/' + customerID + '/parker/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.pageParker = response.data;
            this.loadLeaseData();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },

    calculateParkingFees() {
      let formData = this.$refs['pageForm'].formData;
      formData.lease = formData.lease || [];
      formData['applicationTotalPayable'] = 0.00;
      formData.lease.forEach(leaseData => {
        this.$refs['pageTableLease'].removeLeaseDataSeasonField(leaseData);
      });
      this.$refs['pageTableLease'].setLeaseTotal();

      if(this.checkSeasonFees()) {
        return;
      }

      if(this.checkSeasonTerms()) {
        return;
      }

      let leaseTotal = {};
      this.$refs['pageTableLease'].PRODUCT_PARAMS.forEach(k => leaseTotal[k] = 0);

      let terminationDateText = formData['_terminationDate'];
      let terminationDate;
      if(terminationDateText) {
        terminationDate = helper.parseDateTime(terminationDateText).startOf('day');
      }

      let applyDateText = formData['_applyDate'];
      let applyDate;
      if(applyDateText) {
        applyDate = helper.parseDateTime(applyDateText);
      }

      let tandemCalculated = {};
      formData.lease.forEach(leaseData => {
        if(!this.$refs['pageForm'].formIsAdd) {
          let originalLease = this.pageLicenseLease.find(k => helper.compareID(k.id, leaseData['leaseID']));
          if(originalLease) {
            leaseData['status'] = originalLease['status'];
            leaseData['reason'] = originalLease['reason'];
            leaseData['isBlock'] = originalLease['isBlock'];
            leaseData['passcardID'] = originalLease['passcardID'];
            leaseData['leaseSubscriptionStatus'] = originalLease['status'];
          }
        }

        if(leaseData['isParkAide']) {
          leaseData['leasePasscard'] = 'N/A';
          leaseData['leasePasscardStatus'] = 'ParkAide Blocked';
          if(leaseData['status'] === 'Active' || leaseData['status'] === 'Pending Termination') {
            if(new moment() > helper.parseDateTime(leaseData['commencementDate'])) {
              if(!leaseData['isBlock']) {
                leaseData['leasePasscardStatus'] = 'ParkAide Active';
              }
            }
          }
        } else {
          if(leaseData['passcardID']) {
            leaseData['_passcard'] = this.pagePasscard.find(j => helper.compareID(j.id, leaseData['passcardID']));
            leaseData['leasePasscard'] = leaseData['_passcard'].sku;
            leaseData['leasePasscardStatus'] = 'Passcard Issued';
          } else {
            leaseData['leasePasscard'] = 'N/A'
            if(leaseData['status'] === 'Active' || leaseData['status'] === 'Stop Bill') {
              if(leaseData['reason'].includes('Pending')) {
                leaseData['leasePasscardStatus'] = 'Pending Passcard Issuence';
              } else if(leaseData['reason'].includes('Lost') || leaseData['reason'].includes('Damage')) {
                leaseData['leasePasscardStatus'] =  leaseData['reason'] + ' Passcard';

                let licensePasscardLostDamagedFaultyList = this.pagePasscardLostDamagedFaulty[leaseData['licenseID']] || [];
                let passcardLostDamagedFaultyApplication = licensePasscardLostDamagedFaultyList.find(k => k['leaseID'] === (leaseData['leaseID'] || leaseData['id']));
                if(passcardLostDamagedFaultyApplication) {
                  leaseData['_lostDamageFaultyFormId'] = passcardLostDamagedFaultyApplication['applicationID'];
                  leaseData['_lostDamageFaultyPasscardID'] = passcardLostDamagedFaultyApplication['passcardID'];
                  leaseData['_lostDamageFaultyPasscard'] = this.pagePasscard.find(j => helper.compareID(j.id, leaseData['_lostDamageFaultyPasscardID'])) || {};
                  leaseData['_lostDamageFaultyPasscardSku'] = leaseData['_lostDamageFaultyPasscard']['sku'];
                }
              } else {
                leaseData['leasePasscardStatus'] =  leaseData['reason'] + ' Passcard';
              }
            } else if(leaseData['status'] === 'Pending Termination' || leaseData['status'].includes('Terminated')) {
              if(leaseData['reason'].includes('Pending')) {
                leaseData['leasePasscardStatus'] = 'Pending Passcard Issuence';
              } else if(leaseData['reason'].includes('Returned')) {
                leaseData['leasePasscardStatus'] = 'Passcard Returned';

                let licensePasscardReturnList = this.pagePasscardReturn[leaseData['licenseID']] || [];
                let passcardReturnApplication = licensePasscardReturnList.find(k => k['leaseID'] === (leaseData['leaseID'] || leaseData['id']));
                if(passcardReturnApplication) {
                  leaseData['_returnFormId'] = passcardReturnApplication['applicationID'];
                  leaseData['_returnPasscardID'] = passcardReturnApplication['passcardID'];
                  leaseData['_returnPasscard'] = this.pagePasscard.find(j => helper.compareID(j.id, leaseData['_returnPasscardID'])) || {};
                  leaseData['_returnPasscardSku'] = leaseData['_returnPasscard']['sku'];
                }
              } else if(leaseData['reason'].includes('Lost') || leaseData['reason'].includes('Damage')) {
                leaseData['leasePasscardStatus'] =  leaseData['reason'] + ' Passcard';

                let licensePasscardLostDamagedFaultyList = this.pagePasscardLostDamagedFaulty[leaseData['licenseID']] || [];
                let passcardLostDamagedFaultyApplication = licensePasscardLostDamagedFaultyList.find(k => k['leaseID'] === (leaseData['leaseID'] || leaseData['id']));
                if(passcardLostDamagedFaultyApplication) {
                  leaseData['_lostDamageFaultyFormId'] = passcardLostDamagedFaultyApplication['applicationID'];
                  leaseData['_lostDamageFaultyPasscardID'] = passcardLostDamagedFaultyApplication['passcardID'];
                  leaseData['_lostDamageFaultyPasscard'] = this.pagePasscard.find(j => helper.compareID(j.id, leaseData['_lostDamageFaultyPasscardID'])) || {};
                  leaseData['_lostDamageFaultyPasscardSku'] = leaseData['_lostDamageFaultyPasscard']['sku'];
                }
              } else {
                leaseData['leasePasscardStatus'] =  leaseData['reason'] + ' Passcard';
              }
            }
          }
        }
        
        let applicationPaymentPlan = parseInt(leaseData['paymentPlan']);
        if(applicationPaymentPlan === undefined || applicationPaymentPlan === null) {
          return;
        }

        let applicationCommencementDateText = leaseData['commencementDate'];
        if(applicationCommencementDateText === undefined || applicationCommencementDateText === null) {
          return;
        }

        let applicationCommencementDate = helper.parseDateTime(applicationCommencementDateText).startOf('day');
        let daysInMonth = applicationCommencementDate.daysInMonth();
        let startDay = applicationCommencementDate.date();

        let refundDate
        if(terminationDate.unix() < applicationCommencementDate.unix()) {
          refundDate = moment(applicationCommencementDate).startOf('month')
        } else {
          refundDate = moment(terminationDate).startOf('month')
        }

        let refundableAmount = 0
        for(let invoiceLease of this.billINVLease) {
          if(!helper.compareID(invoiceLease['leaseID'], (leaseData['leaseID'] || leaseData['id']))) {
            continue
          }
          if(invoiceLease['type'] !== 'INIT Fee INV' && invoiceLease['type'] !== 'Monthly Fee INV') {
            continue
          }
          if(!invoiceLease['bill'] || invoiceLease['bill']['voidDate'] || !invoiceLease['bill']['paidDate']) {
            continue
          }
          try {
              invoiceLease['bill']['_dataRef'] = JSON.parse(invoiceLease['bill']['dataRef']);
          } catch(e) {              
          }
          if(invoiceLease['bill']['_dataRef']['billingDate'] < refundDate.unix()) {
            continue
          }
          refundableAmount += invoiceLease['inclusive']
        }
        for(let invoiceLease of this.billDNLease) {
          if(!helper.compareID(invoiceLease['leaseID'], (leaseData['leaseID'] || leaseData['id']))) {
            continue
          }
          if(invoiceLease['type'] !== 'Increase Fee DN') {
            continue
          }
          if(!invoiceLease['bill'] || invoiceLease['bill']['voidDate'] || !invoiceLease['bill']['paidDate']) {
            continue
          }
          try {
              invoiceLease['bill']['_dataRef'] = JSON.parse(invoiceLease['bill']['dataRef']);
          } catch(e) {              
          }
          if(invoiceLease['bill']['_dataRef']['billingDate'] < refundDate.unix()) {
            continue
          }
          refundableAmount += invoiceLease['inclusive']
        }
        for(let invoiceLease of this.billCNLease) {
          if(!helper.compareID(invoiceLease['leaseID'], (leaseData['leaseID'] || leaseData['id']))) {
            continue
          }
          if(invoiceLease['type'] !== 'Decrease Fee CN') {
            continue
          }
          if(!invoiceLease['bill'] || invoiceLease['bill']['voidDate'] || !invoiceLease['bill']['usedDate']) {
            continue
          }
          try {
              invoiceLease['bill']['_dataRef'] = JSON.parse(invoiceLease['bill']['dataRef']);
          } catch(e) {              
          }
          if(invoiceLease['bill']['_dataRef']['billingDate'] < refundDate.unix()) {
            continue
          }
          refundableAmount -= invoiceLease['inclusive']
        }

        if(leaseData['parkerID']) {
          let parker = this.pageParker.find(k => k['id'] === leaseData['parkerID'])
          leaseData['_parker'] = parker;
          leaseData['parkerName'] = parker['name'];
          this.$refs['pageTableLease'].setLeaseDataParker(leaseData, parker);
        } else {
          let parker = this.pageParker.find(k => k['id'] === leaseData['parkerID'])
          leaseData['_parker'] = parker;
          leaseData['parkerName'] = parker['name'];
          this.$refs['pageTableLease'].setLeaseDataParker(leaseData, parker);
        }
        
        let season = this.pageSeason.find(k => helper.compareID(k.id, leaseData['seasonID'])) || {};
        leaseData['leaseProductName'] = season['name']
        leaseData['_season'] = season;

        leaseData['termination'] = '';
        if(this.pageTermination[leaseData['seasonID']] && this.pageTermination[leaseData['seasonID']][0]) {
          let policy = this.pageTermination[leaseData['seasonID']][0].policy;
          policy = policy.replace(/<[^>]*>/g, '');
          if(policy) {
            leaseData['termination'] = '<br><a href="plSeasonTerminationTnCview?seasonID=' + leaseData['seasonID'] + '" target="_blank">Terms</a>'
          }
        }

        let zone = this.pageZone.find(k => helper.compareID(k.id, (season || {})['zoneID']));
        leaseData['leaseZone'] = (zone || {}).name;
        
        let product = this.pageFees[leaseData['seasonID']].find(k => helper.compareID(k.id, leaseData['seasonFees']));
        // if(!product || product.startDate > leaseData['commencementDate']) {
        if(!product) {
          product = this.pageFees[leaseData['seasonID']].find(k => k.isActive)
          if(!product) {
            for(let temp of this.pageFees[leaseData['seasonID']]) {
              if(temp.startDate <= leaseData['commencementDate']) {
                product = temp;
                break;
              }
            }
          }
        }
        if(!product) {
          return;
        }
        
        leaseData['seasonFeesID'] = product.id;

        if(!leaseData.leaseSelected) {
          return;
        }

        product.feesDeposit = parseFloat(product['deposit'] || 0);
        product.feesEstablishment = parseFloat(product['establishment'] || 0);
        product.fees1Month = parseFloat(product['monthly'] || 0);
        product.fees3Month = parseFloat(product['quarterly'] || 0) * 3;
        product.fees6Month = parseFloat(product['halfYearly'] || 0) * 6;
        product.fees12Month = parseFloat(product['annually'] || 0) * 12;
        
        leaseData['commencementDate'] = applicationCommencementDate.unix();
        leaseData['commencementDateText'] = helper.formatDate(leaseData['commencementDate']);
        leaseData['paymentPlan'] = applicationPaymentPlan;

        leaseData['leaseProductDeposit'] = product.feesDeposit;
        leaseData['leaseProductEstbFee'] = product.feesEstablishment;

        switch(applicationPaymentPlan) {
          case 1:
            leaseData['paymentPlanText'] = 'Monthly';
            if(startDay == 1) {
              leaseData['leaseProductInitialParkingFee'] = product.fees1Month;
            } else {
              leaseData['leaseProductInitialParkingFee'] = (daysInMonth - startDay + 1) * (product.fees1Month / daysInMonth);
            }
            leaseData['leaseProductParkingFeePerMonth'] = product.monthly;
            leaseData['leaseProductParkingFee'] = product.fees1Month;

            // leaseData['leaseProRated'] = this.calculateProRated(terminationDate, product.fees1Month);
            // leaseData['leaseProRatedText'] = helper.formatMoney(leaseData['leaseProRated']);
            // leaseData['leaseCreditAmount'] = leaseData['leaseProductParkingFee'] - leaseData['leaseProRated'];
            // leaseData['leaseCreditAmountText'] = helper.formatMoney(leaseData['leaseCreditAmount']);
            leaseData['leaseRefundableFees'] = 0;
            leaseData['leaseRefundableFeesText'] = helper.formatMoney(leaseData['leaseRefundableFees']);
            break;
          case 2:
            leaseData['paymentPlanText'] = 'Quarterly';
            if(startDay == 1) {
              leaseData['leaseProductInitialParkingFee'] = product.fees3Month;
            } else {
              leaseData['leaseProductInitialParkingFee'] = (daysInMonth - startDay + 1) * (product.fees1Month / daysInMonth);
              leaseData['leaseProductInitialParkingFee'] += product.fees3Month;
            }
            leaseData['leaseProductParkingFeePerMonth'] = product.quarterly;
            leaseData['leaseProductParkingFee'] = product.fees3Month;

            // leaseData['leaseProductParkingFeePerMonth'] = product.fees1Month;
            // leaseData['leaseProductParkingFee'] = product.fees1Month;

            leaseData['leaseProductParkingFeeText'] = helper.formatMoney(leaseData['leaseProductParkingFee']) + ' / month';
            
            // leaseData['leaseProRated'] = this.calculateProRated(terminationDate, product.fees3Month);
            // leaseData['leaseProRatedText'] = helper.formatMoney(leaseData['leaseProRated']);
            // leaseData['leaseCreditAmount'] = leaseData['leaseProductParkingFee'] - leaseData['leaseProRated'];
            // leaseData['leaseCreditAmountText'] = helper.formatMoney(leaseData['leaseCreditAmount']);
            leaseData['leaseRefundableFees'] = 0;
            leaseData['leaseRefundableFeesText'] = helper.formatMoney(leaseData['leaseRefundableFees']);
            break;
          case 3:
            leaseData['paymentPlanText'] = 'Half-yearly';
            if(startDay == 1) {
              leaseData['leaseProductInitialParkingFee'] = product.fees6Month;
            } else {
              leaseData['leaseProductInitialParkingFee'] = (daysInMonth - startDay + 1) * (product.fees1Month / daysInMonth);
              leaseData['leaseProductInitialParkingFee'] += product.fees6Month;
            }
            leaseData['leaseProductParkingFeePerMonth'] = product.halfYearly;
            leaseData['leaseProductParkingFee'] = product.fees6Month;

            // leaseData['leaseProductParkingFeePerMonth'] = product.fees1Month;
            // leaseData['leaseProductParkingFee'] = product.fees1Month;

            leaseData['leaseProductParkingFeeText'] = helper.formatMoney(leaseData['leaseProductParkingFee']) + ' / month';
            
            // leaseData['leaseProRated'] = this.calculateProRated(terminationDate, product.fees6Month);
            // leaseData['leaseProRatedText'] = helper.formatMoney(leaseData['leaseProRated']);
            // leaseData['leaseCreditAmount'] = leaseData['leaseProductParkingFee'] - leaseData['leaseProRated'];
            // leaseData['leaseCreditAmountText'] = helper.formatMoney(leaseData['leaseCreditAmount']);
            leaseData['leaseRefundableFees'] = 0;
            leaseData['leaseRefundableFeesText'] = helper.formatMoney(leaseData['leaseRefundableFees']);
            break;
          case 4:
            leaseData['paymentPlanText'] = 'Annually';
            if(startDay == 1) {
              leaseData['leaseProductInitialParkingFee'] = product.fees12Month;
            } else {
              leaseData['leaseProductInitialParkingFee'] = (daysInMonth - startDay + 1) * (product.fees1Month / daysInMonth);
              leaseData['leaseProductInitialParkingFee'] += product.fees12Month;
            }
            leaseData['leaseProductParkingFeePerMonth'] = product.annually;
            leaseData['leaseProductParkingFee'] = product.fees12Month;

            // leaseData['leaseProductParkingFeePerMonth'] = product.fees1Month;
            // leaseData['leaseProductParkingFee'] = product.fees1Month;

            leaseData['leaseProductParkingFeeText'] = helper.formatMoney(leaseData['leaseProductParkingFee']) + ' / annual';
            
            // leaseData['leaseProRated'] = this.calculateProRated(terminationDate, product.fees12Month);
            // leaseData['leaseProRatedText'] = helper.formatMoney(leaseData['leaseProRated']);
            // leaseData['leaseCreditAmount'] = leaseData['leaseProductParkingFee'] - leaseData['leaseProRated'];
            // leaseData['leaseCreditAmountText'] = helper.formatMoney(leaseData['leaseCreditAmount']);
            leaseData['leaseRefundableFees'] = 0;
            leaseData['leaseRefundableFeesText'] = helper.formatMoney(leaseData['leaseRefundableFees']);
            break;
        }

        leaseData['leaseProductParkingFeePerMonthText'] = helper.formatMoney(leaseData['leaseProductParkingFeePerMonth']) + ' / monthly';
        leaseData['leaseProductParkingFeePerMonth1'] = leaseData['leaseProductParkingFeePerMonth'];
        leaseData['leaseProductParkingFeePerMonth1Text'] = leaseData['leaseProductParkingFeePerMonthText'];
        leaseData['leaseProductInitialPayment'] = product.feesDeposit + product.feesEstablishment + leaseData['leaseProductInitialParkingFee'];

        let minParkingDate
        if(season.minParkingDay === 0) {
          minParkingDate = helper.getOneCalendarMonthLater(applicationCommencementDate)
        } else if(season.minParkingDay === -1) {
          minParkingDate = moment(applicationCommencementDate).subtract(1, 'day')
        } else {
          minParkingDate = moment(applicationCommencementDate).add('day', season.minParkingDay - 1)
        }
        if(terminationDate < minParkingDate) {
          let daysOfMonth = terminationDate.daysInMonth();
          leaseData['leaseProRated'] = leaseData['leaseProductParkingFeePerMonth'];
          leaseData['leaseProRatedText'] = helper.formatMoney(leaseData['leaseProRated']);
          if(season.minParkingDay === 0) {
            leaseData['leaseNoticeText'] = '<span class="text-danger">Insufficient Parking Period. Min parking one calendar month.</span>';
          } else if(season.minParkingDay === -1) {
            leaseData['leaseNoticeText'] = '<span class="text-danger">Insufficient Parking Period. Min parking 0 day.</span>';
          } else {
            leaseData['leaseNoticeText'] = '<span class="text-danger">Insufficient Parking Period. Min parking ' + season.minParkingDay + ' days</span>';
          }
        } else {
          let daysOfMonth = terminationDate.daysInMonth();
          leaseData['leaseProRated'] = terminationDate.date() / daysOfMonth * leaseData['leaseProductParkingFeePerMonth'];
          leaseData['leaseProRatedText'] = helper.formatMoney(leaseData['leaseProRated']);
          leaseData['leaseNoticeText'] = '';
        }

        leaseData['leaseRefundableFees'] = refundableAmount - leaseData['leaseProRated']
        leaseData['leaseRefundableFees'] = leaseData['leaseRefundableFees'] > 0 ? leaseData['leaseRefundableFees'] : 0
        leaseData['leaseRefundableFeesText'] = helper.formatMoney(leaseData['leaseRefundableFees']);

        leaseData['leaseCreditAmount'] = leaseData['leaseProductParkingFeePerMonth'] - leaseData['leaseProRated'];
        leaseData['leaseCreditAmountText'] = helper.formatMoney(leaseData['leaseCreditAmount']);
        
        let minTerminationDate
        if(season.durationTerminateDayNotice === 0) {
          minTerminationDate = helper.getOneCalendarMonthLater(applyDate)
        } else if(season.durationTerminateDayNotice === -1) {
          minTerminationDate = moment(applyDate).subtract(1, 'day')
        } else {
          minTerminationDate = moment(applyDate).add(season.durationTerminateDayNotice - 1, 'day')
        }
        if(terminationDate.unix() < minTerminationDate.unix()) {
          leaseData['leaseNoticeText'] = '<span class="text-danger">Insufficient notice period. Deposit will be forfeited.</span>';
        }

        this.$refs['pageTableLease'].PRODUCT_PARAMS.forEach(k => {
          tandemCalculated[k] = tandemCalculated[k] || [];

          let originalLease = leaseData['leaseID'] ? this.latestLease.find(k => k.id === leaseData['leaseID']) : leaseData
          if(!originalLease['pairID']) {
            leaseTotal[k] += leaseData[k];
          } else if(!tandemCalculated[k].includes(originalLease['pairID'])) {
            leaseTotal[k] += leaseData[k];
            tandemCalculated[k].push(originalLease['pairID']);
          }
          
          leaseData[k + 'Text'] = leaseData[k + 'Text'] || helper.formatMoney(leaseData[k]);
        });
      });

      this.$refs['pageTableLease'].setLeaseTotal(leaseTotal);
      formData['applicationTotalPayable'] = leaseTotal['leaseProductInitialPaymentText'];

      this.hideFormFromKey(null);
    },
    calculateProRated(terminationDate, parkingFees) {
      if(!terminationDate) {
        return 0;
      }

      let terminationDay = terminationDate.date();
      let terminationMonthDay = moment(terminationDate).endOf('month').date();
      return parkingFees / terminationMonthDay * terminationDay;
    },
    checkSeasonFees() {
      let formData = this.$refs['pageForm'].formData;
      for(let leaseData of formData.lease) {
        if(leaseData['seasonID'] && this.pageFees[leaseData['seasonID']] === undefined) {
          // load season fees
          this.loadSeasonFees(leaseData['seasonID']);
          return true;
        }
      };
    },
    checkSeasonTerms() {
      let formData = this.$refs['pageForm'].formData;
      for(let leaseData of formData.lease) {
        if(leaseData['seasonID'] && this.pageTermination[leaseData['seasonID']] === undefined) {
          // load season termination terms
          this.loadSeasonTermination(leaseData['seasonID']);
          return true;
        }
      };
    },
    checkPasscardReturn() {
      let formData = this.$refs['pageForm'].formData;
      for(let leaseData of formData.lease) {
        if(leaseData['data4'] && this.pagePasscardReturn[leaseData['data4']] === undefined) {
          // load passcard return form
          this.loadPasscardReturn(leaseData['data4']);
          return true;
        }
      };
    },
    

    onCancelButtonClick() {
      let url = this.$route.query.pending ? helper.WEB_URL + '/plTerminationPending' : helper.WEB_URL + '/plTermination';
      helper.redirect({ path: url, query: { carparkID: this.$refs['pageForm'].formData['carparkID'] }});
    },
    onSaveButtonClick() {
      if(!this.$refs['pageForm'].validateForm() && !this.validateApplicationData()) {
        if(this.$refs['pageForm'].formIsAdd) {
          this.addApplication({});
        } else {
          this.editApplication({});
        }
        this.pageEnableSubmit = false
      } else {
        this.pageEnableSubmit = true
      }
    },
    validateApplicationData() {
      let formData = this.$refs['pageForm'].formData;
      let hasSelected = false;
      if(!formData.lease.find(k => k.leaseSelected)) {
        this.$refs['pageTableLease'].$refs['leaseFeedback'].setFeedbackError('Please select at least one subscription to proceed');
        $(document).scrollTop($('#jt-form-div-sectionProductSubscription')[0].offsetTop);
        return true;
      }

      if(helper.compareID(formData['refundMethod'], 0)) {
        if(!formData['terminationGiroAccountHolder']) {
          this.$refs['pageForm'].$refs['jt-form-element-terminationGiroAccountHolder'][0].setInputError(`Please input valid GIRO bank account name`);
          return true;
        }

        if(!formData['terminationGiroEmail']) {
          this.$refs['pageForm'].$refs['jt-form-element-terminationGiroEmail'][0].setInputError(`Please input valid GIRO bank account email`);
          return true;
        }

        let bankConfig = this.PARAM_MAP['terminationGiroBank'].form_select.data.find(k => helper.compareID(k.id, formData['terminationGiroBank']));
        if(!formData['terminationGiroBank'] || !bankConfig) {
          this.$refs['pageForm'].$refs['jt-form-element-terminationGiroBank'][0].setInputError(`Please select valid GIRO bank`);
          return true;
        }

        let accountType = formData['terminationGiroBankAccountType'];
        if(!formData['terminationGiroBankAccountType']) {
          this.$refs['pageForm'].$refs['jt-form-element-terminationGiroBankAccountType'][0].setInputError(`Please select valid GIRO bank account type`);
          return true;
        }

        let bankAccountNo = formData['terminationGiroBankAccountNo'].trim();
        if(!bankAccountNo || !(/^\d+$/.test(bankAccountNo))) {
          this.$refs['pageForm'].$refs['jt-form-element-terminationGiroBankAccountNo'][0].setInputError(`Please input valid GIRO bank account number`);
          return true;
        }
        
        let accountNoValid = false;
        let bankAccountConfigKey = accountType === 'current' ? 'ca' : 'sa'
        for(let bankAccountConfig of bankConfig[bankAccountConfigKey]) {
          if(bankAccountConfig.exact) {
            if(bankAccountNo.length === bankAccountConfig.exact) {
              accountNoValid = true;
              break;
            }
            if(bankAccountNo.length >= bankAccountConfig.min && bankAccountNo.length <= bankAccountConfig.max) {
              accountNoValid = true;
              break;
            }
          }
        }
        if(!accountNoValid) {
          this.$refs['pageForm'].$refs['jt-form-element-terminationGiroBankAccountNo'][0].setInputError(`Please input valid GIRO bank account number`);
          return true;
        }

        if(!formData['terminationGiroNewIC'] && !formData['terminationGiroOldIC'] && !formData['terminationGiroBusinessRegNo']) {
          this.$refs['pageForm'].$refs['jt-form-element-terminationGiroBusinessRegNo'][0].setInputError(`Please fill in at least one of the GIRO Verification Method`);
          return true;
        }
      } else if(helper.compareID(formData['refundMethod'], 1)) {
        if(!formData['terminationChequePayableTo']) {
          this.$refs['pageForm'].$refs['jt-form-element-terminationChequePayableTo'][0].setInputError(`Please input valid cheque payable to field`);
          return true;
        }
        if(!formData['terminationChequeAddress1']) {
          this.$refs['pageForm'].$refs['jt-form-element-terminationChequeAddress1'][0].setInputError(`Please input valid cheque address 1`);
          return true;
        }
        if(!formData['terminationChequePostalCode']) {
          this.$refs['pageForm'].$refs['jt-form-element-terminationChequePostalCode'][0].setInputError(`Please input valid cheque address postal code`);
          return true;
        }
        if(!formData['terminationChequeCity']) {
          this.$refs['pageForm'].$refs['jt-form-element-terminationChequeCity'][0].setInputError(`Please input valid cheque address city`);
          return true;
        }
        if(!formData['terminationChequeState']) {
          this.$refs['pageForm'].$refs['jt-form-element-terminationChequeState'][0].setInputError(`Please input valid cheque address state`);
          return true;
        }
        if(!formData['terminationChequeCountry']) {
          this.$refs['pageForm'].$refs['jt-form-element-terminationChequeCountry'][0].setInputError(`Please input valid cheque address country`);
          return true;
        }
      }

      if(!formData['applicationTnC']) {
        this.$refs['pageFeedback'].setFeedbackError('Please agree to the terms and conditions to proceed');
        return true;
      }

      this.$refs['pageTableLease'].$refs['leaseFeedback'].setFeedbackError('');
      this.$refs['pageForm'].$refs['jt-form-element-terminationGiroAccountHolder'][0].setInputError('');
      this.$refs['pageForm'].$refs['jt-form-element-terminationGiroEmail'][0].setInputError('');
      this.$refs['pageForm'].$refs['jt-form-element-terminationGiroBank'][0].setInputError('');
      this.$refs['pageForm'].$refs['jt-form-element-terminationGiroBankAccountType'][0].setInputError('');
      this.$refs['pageForm'].$refs['jt-form-element-terminationGiroBankAccountNo'][0].setInputError('');
      this.$refs['pageForm'].$refs['jt-form-element-terminationGiroBusinessRegNo'][0].setInputError('');

      this.$refs['pageForm'].$refs['jt-form-element-terminationChequePayableTo'][0].setInputError('');
      this.$refs['pageForm'].$refs['jt-form-element-terminationChequeAddress1'][0].setInputError('');
      this.$refs['pageForm'].$refs['jt-form-element-terminationChequePostalCode'][0].setInputError('');
      this.$refs['pageForm'].$refs['jt-form-element-terminationChequeCity'][0].setInputError('');
      this.$refs['pageForm'].$refs['jt-form-element-terminationChequeState'][0].setInputError('');
      this.$refs['pageForm'].$refs['jt-form-element-terminationChequeCountry'][0].setInputError('');
      this.$refs['pageFeedback'].setFeedbackError('');

      // TODO kw1 validate refund method field
      // console.log('everything ok')
      // return true;
    },

    async addData(formData) {
      let dataref = {};
      if(helper.compareID(formData['refundMethod'], 0)) {
        dataref['terminationGiroAccountHolder'] = formData['terminationGiroAccountHolder']
        dataref['terminationGiroEmail'] = formData['terminationGiroEmail']
        dataref['terminationGiroBank'] = formData['terminationGiroBank']
        let bankConfig = this.PARAM_MAP['terminationGiroBank'].form_select.data.find(k => helper.compareID(k.id, formData['terminationGiroBank']));
        dataref['terminationGiroBankName'] = bankConfig.name
        dataref['terminationGiroBankAccountType'] = formData['terminationGiroBankAccountType']
        dataref['terminationGiroBankAccountNo'] = formData['terminationGiroBankAccountNo']
        dataref['terminationGiroNewIC'] = formData['terminationGiroNewIC']
        dataref['terminationGiroOldIC'] = formData['terminationGiroOldIC']
        dataref['terminationGiroBusinessRegNo'] = formData['terminationGiroBusinessRegNo']
      } else if(helper.compareID(formData['refundMethod'], 1)) {
        dataref['terminationChequePayableTo'] = formData['terminationChequePayableTo']
        dataref['terminationChequeAddress1'] = formData['terminationChequeAddress1']
        dataref['terminationChequeAddress2'] = formData['terminationChequeAddress2']
        dataref['terminationChequeAddress3'] = formData['terminationChequeAddress3']
        dataref['terminationChequePostalCode'] = formData['terminationChequePostalCode']
        dataref['terminationChequeCity'] = formData['terminationChequeCity']
        dataref['terminationChequeState'] = formData['terminationChequeState']
        dataref['terminationChequeCountry'] = formData['terminationChequeCountry']
      }

      let leaseSelected = (formData['lease'].find(k => k.leaseSelected) || {})

      let feedbackItem = 'parking license termination application data';
      this.$refs['pageFeedback'].setFeedbackLoading('Adding ' + feedbackItem);
      let dataResult = await this.$http
        .post(
          helper.SERVER_URL + '/api2/data',
          querystring.stringify({
            leaseID: leaseSelected.leaseID || leaseSelected.id || '',
            data: JSON.stringify(dataref),
          }),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          return response.data;
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'adding', feedbackItem));
        })
      
      return dataResult;
    },

    async addApplication(data) {
      let formData = this.$refs['pageForm'].formData;
      let dataResult = await this.addData(formData);

      if(!dataResult) {
        return;
      }

      let temp = {}
      temp['carparkID'] = formData['carparkID'];
      temp['dataID'] = dataResult.dataID;
      temp['terminationDate'] = helper.parseDateTime(formData['_terminationDate']).unix();
      temp['terminationReason'] = formData['_terminationReason']
      temp['applyDate'] = helper.parseDateTime(formData['_applyDate']).unix();
      temp['contactNo'] = formData['contactNo'];
      temp['refundMethod'] = formData['refundMethod'];
      // TODO kw1 refund detail
      temp['applicationStaff'] = formData['applicationStaff'];
      temp['operatorID'] = this.pageCarpark.find(k => helper.compareID(k.id, formData['carparkID'])).operatorID;
      temp['leases'] = JSON.stringify(formData['lease'].filter(k => k.leaseSelected));

      let feedbackItem = 'parking license termination application';
      this.$refs['pageFeedback'].setFeedbackLoading('Adding ' + feedbackItem);
      this.$http
        .post(
          helper.API_URL + '/api2/licenseTerminate/create1',
          querystring.stringify(temp),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully added ' + feedbackItem);
        })
        .catch(error => {
          this.pageEnableSubmit = true
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'adding', feedbackItem));
        })
    },
    async editApplication(data) {
      let formData = this.$refs['pageForm'].formData;
      let dataResult = await this.addData(formData);

      if(!dataResult) {
        return;
      }
      
      let temp = {};
      temp['terminationDate'] = helper.parseDateTime(formData['_terminationDate']).unix();
      temp['terminationReason'] = formData['_terminationReason']
      temp['contactNo'] = formData['contactNo'];
      temp['refundMethod'] = formData['refundMethod'];
      // TODO kw1 refund detail
      temp['applicationStaff'] = formData['applicationStaff'];
      temp['leases'] = JSON.stringify(formData['lease']);
      temp['dataID'] = dataResult.dataID;

      let feedbackItem = 'parking license termination application';
      this.$refs['pageFeedback'].setFeedbackLoading('Updating ' + feedbackItem);
      this.$http
        .put(
          helper.API_URL + '/api2/licenseTerminate/update',
          querystring.stringify(temp),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully update ' + feedbackItem);
        })
        .catch(error => {
          this.pageEnableSubmit = true
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'updating', feedbackItem));
        })
    },
    upsertDataComplete(message) {
      this.$refs['pageFeedback'].setFeedbackMessage(message);
      let url = this.$route.query.pending ? helper.WEB_URL + '/plTerminationPending' : helper.WEB_URL + '/plTermination';
      helper.redirect({ path: url, query: { carparkID: this.$refs['pageForm'].formData['carparkID'] }});
    },

    onFormInput(formData, formParameter, input) {
      if(formParameter.key === 'carparkID') {
        formData['licenseID'] = null;
        formData['_lease'] = [];
        formData['lease'] = [];
        this.loadLicense();
      } else if(formParameter.key === '_terminationReason') {
        if((formData['_terminationReason'] || '').length >= 128) {
          formData['_terminationReason'] = formData['_terminationReason'].substring(0, 128)
          this.$refs['pageForm'].$refs['jt-form-element-_terminationReason'][0].setInputError('Reason for termination has a maximum length of 128');
        } else {
          this.$refs['pageForm'].$refs['jt-form-element-_terminationReason'][0].setInputError();
        }
      } else if(formParameter.key === 'terminationChequeCity') {
        this.onFormCityChange();
      } else if(formParameter.key === 'licenseID') {
        formData['_lease'] = [];
        formData['lease'] = [];
        this.onLicenseChange();
      } else if(formParameter.key === '_lease') {
        this.forceTerminationOnLastDayOfMonth = false
        formData['lease'].forEach(k => {
          if(formData['_lease'].includes('All Subscription')) {
            k.leaseSelected = true;
          } else {
            k.leaseSelected = formData['_lease'].includes('' + k.id);
          }

          if(k.leaseSelected) {
            let temp = (this.pageProduct.find(j => j['id'] === k['seasonID']) || {})
            this.forceTerminationOnLastDayOfMonth = this.forceTerminationOnLastDayOfMonth || temp['terminationLastDay']
          }
        });

        if(this.forceTerminationOnLastDayOfMonth) {
          if(formData['_terminationDate']) {
            let selected = helper.parseDateTime(formData['_terminationDate']).startOf('day')
            let lastDayOfMonth = helper.parseDateTime(formData['_terminationDate']).endOf('month').startOf('day')
            if(selected.unix() !== lastDayOfMonth.unix()) {
              formData['_terminationDate'] = helper.formatDate(lastDayOfMonth);
            }
          }
        }
        $('#jt-form-input-_terminationDate').datepicker('update');

        // if one tandem is selected, the pair/group must select together
        if(!formData['_lease'].includes('All Subscription')) {
          formData['lease'].forEach(k => {
            if(k.leaseSelected && k.pairID) {
              formData['lease'].forEach(j => {
                if(j.pairID === k.pairID) {
                  j.leaseSelected = true;
                }
              });
            }
          });
        }

        this.$refs['pageTableLease'].$forceUpdate();
        this.calculateParkingFees();
      } else if(formParameter.key === '_applyDate') {
        this.calculateParkingFees();
      } else if(formParameter.key === '_terminationDate') {
        this.onTerminationDateChange();
        this.calculateParkingFees();
      } else if(formParameter.key === 'refundMethod') {
        this.hideFormFromKey(null);
      } else if(formParameter.key === 'applicationStaff') {
        this.onApplicationStaffChange();
      } else if(formParameter.key === 'terminationGiroBank') {
        this.onBankChange();
      } else if(formParameter.key === 'terminationGiroBankAccountType') {
        this.onBankChange();
      } else if(formParameter.key === 'terminationGiroBusinessRegNo') {
        formData['terminationGiroBusinessRegNo_edit'] = true;
      } else if(formParameter.key === 'terminationGiroNewIC') {
        formData['terminationGiroNewIC_edit'] = true;
      }
    },
    onFormCityChange() {
      let formData = this.$refs['pageForm'].formData;
      formData['terminationChequeState'] = null;
      formData['terminationChequeCountry'] = null;
      
      let selectedCity = helper.inputSelectFindOption(PARAM_MAP['terminationChequeCity'], formData['terminationChequeCity']);
      if(!selectedCity) {
        return this.$refs['pageForm'].$forceUpdate();
      }

      let selectedState = helper.inputSelectFindOption(PARAM_MAP['terminationChequeState'], selectedCity.stateID);
      if(!selectedState) {
        return this.$refs['pageForm'].$forceUpdate();
      }
      formData['terminationChequeState'] = selectedState.id;

      let selectedCountry = helper.inputSelectFindOption(PARAM_MAP['terminationChequeCountry'], selectedState.countryID);
      if(!selectedCountry) {
        return this.$refs['pageForm'].$forceUpdate();
      }
      formData['terminationChequeCountry'] = selectedCountry.id;
      return this.$refs['pageForm'].$forceUpdate();
    },
    onLicenseChange() {
      let formData = this.$refs['pageForm'].formData;
      let license = this.pageLicense.find(k => helper.compareID(k.id, formData['licenseID']));
      let customerID = (this.pageLicense.find(k => helper.compareID(k.id, formData['licenseID'])) || {}).customerID;
      let customer = this.pageCustomer.find(k => helper.compareID(k.id, customerID));
      if(customer) {
        formData['terminationChequePayableTo'] = customer.name

        if(customer.isCompany) {
          if(!formData['terminationGiroBusinessRegNo'] || !formData['terminationGiroBusinessRegNo_edit']) {
            formData['terminationGiroNewIC'] = '';
            formData['terminationGiroBusinessRegNo'] = customer['nationalID'];
            formData['terminationGiroBusinessRegNo_edit'] = false;
          }
        } else {
          if(!formData['terminationGiroNewIC'] || !formData['terminationGiroNewIC_edit']) {
            formData['terminationGiroBusinessRegNo'] = '';
            formData['terminationGiroNewIC'] = customer['nationalID'];
            formData['terminationGiroNewIC_edit'] = false;
          }
        }

        this.loadCustomerAddress(customer)
      } else {
        this.hideFormFromKey('sectionProductSubscription');
        this.$refs['pageFeedback'].setFeedbackError('Problem loading customer info');
      }
    },
    loadCustomerAddress() {
      let formData = this.$refs['pageForm'].formData;
      let license = this.pageLicense.find(k => helper.compareID(k.id, formData['licenseID']));
      let customerID = (this.pageLicense.find(k => helper.compareID(k.id, formData['licenseID'])) || {}).customerID;
      let customer = this.pageCustomer.find(k => helper.compareID(k.id, customerID));
      this.hideFormFromKey('sectionProductSubscription');

      let feedbackItem = 'customer address';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      
      this.$http
        .get(
          helper.SERVER_URL + '/api2/address/' + customer['address1'],
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          let result = helper.parseAddress(response);

          if(result) {
            if(this.$refs['pageForm'].formIsAdd) {
              if(customer.isCompany) {
                formData['terminationChequeAddress1'] = result.companyAddress1
                formData['terminationChequeAddress2'] = result.companyAddress2
                formData['terminationChequeAddress3'] = result.companyAddress3
                formData['terminationChequePostalCode'] = result.companyAddressPostalCode
                formData['terminationChequeCity'] = result.companyAddressCityID
              } else {
                formData['terminationChequeAddress1'] = result.personalCorrespondenceAddress1
                formData['terminationChequeAddress2'] = result.personalCorrespondenceAddress2
                formData['terminationChequeAddress3'] = result.personalCorrespondenceAddress3
                formData['terminationChequePostalCode'] = result.personalCorrespondenceAddressPostalCode
                formData['terminationChequeCity'] = result.personalCorrespondenceAddressCityID
              }
              this.onFormCityChange();
            }

            this.loadLicenseLease();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('Problem loading customer address');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    onTerminationDateChange() {
      let formData = this.$refs['pageForm'].formData;
      let terminationDate = helper.parseDateTime(formData['_terminationDate']);
      // if(this.$refs['pageForm'].formIsAdd) {
      //   let oneCalendarMonth = moment().startOf('day');
      //   if(oneCalendarMonth.date() > 1) {
      //     oneCalendarMonth.subtract(1, 'day');
      //   }
      //   oneCalendarMonth.add(1, 'month')
      //   if(terminationDate < oneCalendarMonth) {
      //     this.$refs['terminationDateFeedback'].setFeedbackError('Insufficient Notice Period, Deposit will be forfeited');
      //   } else {
      //     this.$refs['terminationDateFeedback'].setFeedbackError(null);
      //   }
      // } else {
      //   if(terminationDate < helper.parseDateTime(formData['createDate']).startOf('day').add(1, 'month').subtract(1, 'day')) {
      //     this.$refs['terminationDateFeedback'].setFeedbackError('Insufficient Notice Period, Deposit will be forfeited');
      //   } else {
      //     this.$refs['terminationDateFeedback'].setFeedbackError(null);
      //   }
      // }
    },
    onApplicationStaffChange() {
      let staff = helper.inputSelectFindOption(this.PARAM_MAP['applicationStaff'], this.$refs['pageForm'].formData['applicationStaff']) || {}
      this.$refs['pageForm'].formData['applicationStaffNo'] = staff['personnelCode'];
    },
    onBankChange() {
      let formData = this.$refs['pageForm'].formData;
      let bankConfig = this.PARAM_MAP['terminationGiroBank'].form_select.data.find(k => helper.compareID(k.id, formData['terminationGiroBank']));
      let accountType = formData['terminationGiroBankAccountType'] || '';

      if(bankConfig) {
        let hint = '';
        let hintExtend = '';

        if(bankConfig['ca'] && bankConfig['ca'].length > 0 && bankConfig['sa'] && bankConfig['sa'].length > 0) {
          this.PARAM_MAP['terminationGiroBankAccountType'].form_select = [
            {'current':'Current Account'}, 
            {'saving':'Saving Account'},
          ]
        } else if(bankConfig['ca'] && bankConfig['ca'].length > 0) {
          this.PARAM_MAP['terminationGiroBankAccountType'].form_select = [
            {'current':'Current Account'}, 
          ]
          accountType = formData['terminationGiroBankAccountType'] = 'current'
        } else if(bankConfig['sa'] && bankConfig['sa'].length > 0) {
          this.PARAM_MAP['terminationGiroBankAccountType'].form_select = [
            {'saving':'Saving Account'},
          ]
          accountType = formData['terminationGiroBankAccountType'] = 'saving'
        } else {
          this.PARAM_MAP['terminationGiroBankAccountType'].form_select = [
          ]
          this.PARAM_MAP['terminationGiroBankAccountNo'].form_muted = '';
        }

        hintExtend = '';
        let bankAccountConfigKey = accountType === 'current' ? 'ca' : 'sa'
        for(let bankAccountConfig of bankConfig[bankAccountConfigKey]) {
          if(!hintExtend) {
            hintExtend = accountType.charAt(0).toUpperCase() + accountType.slice(1) + ' account number should have length of ';
          } else {
            hintExtend += ', '
          }

          if(bankAccountConfig.exact) {
            hintExtend += bankAccountConfig.exact;
          }
          if(bankAccountConfig.min) {
            hintExtend += bankAccountConfig.min;
          }
          if(bankAccountConfig.max) {
            hintExtend += ' - ' + bankAccountConfig.max;
          }
        }
        hint += hintExtend ? hintExtend + '<br>' : '';

        this.PARAM_MAP['terminationGiroBankAccountNo'].form_muted = `<span style="color: #1e88e5">${hint || ''}</span>`;
      }
    },

    onApproveButtonClick() {
      this.updateApplicationStatus('approve');
    },
    onReachTerminationButtonClick() {
      this.updateApplicationStatus('reachTermination');
    },
    onReachTermination14ButtonClick() {
      this.updateApplicationStatus('reachTermination14');
    },
    onCompleteButtonClick() {
      this.updateApplicationStatus('refund');
    },
    updateApplicationStatus(action) {
      let formData = this.$refs['pageForm'].formData;

      let feedbackItem = 'parking license termination application status';
      this.$refs['pageFeedback'].setFeedbackLoading('Updating ' + feedbackItem);
      this.$http
        .post(
          helper.API_URL + '/api2/licenseTerminate/' + action,
          querystring.stringify({ applicationID: formData['applicationID'] }),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully update ' + feedbackItem);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'updating', feedbackItem));
        })
    },

    hasAddOrEditPermission() {
      return this.pageIsAdd ? helper.hasAddPermission(this.permission) : helper.hasEditPermission(this.permission);
    },
    hasDeletePermission() {
      return helper.hasDeletePermission(this.permission);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/ParkingLicense/PagePLTerminationForm.vue